/**
 * Get the file name form file path
 *
 * @param {string} filePath
 * @returns {string} fileName
 */
import axios from "axios";

export function getFileNameFromFilepath(filePath: string): string {
  return filePath.replace(/^.*[\\/]/, "").split("?")[0];
}

/**
 * Download csv file from file path
 *
 * @param {string} filePath
 * @returns {void}
 */
export const downloadFile = (filePath: string): void => {
  axios({
    url: filePath,
    method: "GET",
    responseType: "blob",
  }).then((response) => {
    const fileName = filePath.split("/").pop()?.split("?")[0] || "download";
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  });
};

/**
 * Download Image file from file path
 *
 * @param {string} filePath
 * @returns {void}
 */
export const downloadImage = (filePath: string): void => {
  axios({
    url: filePath,
    method: "GET",
    responseType: "blob",
  }).then((response) => {
    const fileName = filePath.split("/").pop()?.split("?")[0] || "download";
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  });
};

/**
 * Get the file extension from file path
 * */
export function getFileExtension(filePath: string): string {
  return filePath.split(".").pop() || "";
}
